import { platformApiFetch } from '@/services/platformApi/client';

export interface FavoriteData {
  id?: string;
  user_id: string;
  provider_id: string;
  created_at?: string;
}

/**
 * Fetch all favorites for a user
 */
export async function getUserFavorites(userId: string): Promise<string[]> {
  return platformApiFetch<string[]>(`/v1/favorites/${userId}`);
}

/**
 * Add a favorite for a user
 */
export async function addFavorite(userId: string, providerId: string): Promise<void> {
  await platformApiFetch('/v1/favorites', {
    method: 'POST',
    body: JSON.stringify({ user_id: userId, provider_id: providerId }),
  });
}

/**
 * Remove a favorite for a user
 */
export async function removeFavorite(userId: string, providerId: string): Promise<void> {
  await platformApiFetch(`/v1/favorites/${userId}/${providerId}`, {
    method: 'DELETE',
  });
}

/**
 * Check if a provider is favorited by a user
 */
export async function isFavorited(userId: string, providerId: string): Promise<boolean> {
  return platformApiFetch<boolean>(`/v1/favorites/${userId}/${providerId}`);
}
